package br.com.htms.inspeccaocampo.data

object ComunicacaoOcorrenciasValidacao {

    fun validar(
        form: FormComunicacaoOcorrencias,
        config: AppConfig = InspecaoCatalog.config()
    ): List<ErroCampo> {
        val erros = mutableListOf<ErroCampo>()
        fun ativo(id: String) = config.ocorrenciaAtiva(id)
        fun exigir(campo: String, valor: String, mensagem: String) {
            if (valor.isBlank()) erros += ErroCampo(campo, mensagem)
        }

        if (ativo("cliente")) exigir("cliente", form.cliente, "Informe o cliente.")
        if (ativo("obra")) exigir("obra", form.obra, "Selecione a obra.")
        if (ativo("caracterizacao") && form.caracterizacao == null) {
            erros += ErroCampo("caracterizacao", "Selecione a caracterização.")
        }
        if (ativo("tipo") && form.tipo == null) {
            erros += ErroCampo("tipo", "Selecione o tipo (Típico/Trajeto).")
        }
        if (ativo("dataHoraOcorrido")) {
            exigir("dataHoraOcorrido", form.dataHoraOcorrido, "Informe a data e hora do ocorrido.")
        }
        if (ativo("localExato")) {
            exigir("localExato", form.localExato, "Informe o local exato (setor/frente de serviço).")
        }
        if (ativo("quemReportando")) {
            exigir("quemReportando", form.quemReportando, "Informe quem está reportando.")
        }
        if (ativo("tipoEvento") && form.tipoEvento == null) {
            erros += ErroCampo("tipoEvento", "Selecione o tipo de evento (classe).")
        }
        if (ativo("envolvido")) {
            exigir("envolvidoNome", form.envolvidoNome, "Informe o nome do envolvido.")
            exigir("envolvidoFuncao", form.envolvidoFuncao, "Informe a função do envolvido.")
        }
        if (ativo("responsavel")) {
            exigir("responsavelAtividade", form.responsavelAtividade, "Informe o responsável pela atividade.")
            exigir("responsavelCargo", form.responsavelCargo, "Informe o cargo do responsável.")
            if (form.responsavelEstavaNoLocal == null) {
                erros += ErroCampo("responsavelEstavaNoLocal", "Informe se o responsável estava no local.")
            }
        }
        if (ativo("dadosAcidente")) {
            exigir("dataAcidente", form.dataAcidente, "Informe a data do acidente.")
            exigir("horaAcidente", form.horaAcidente, "Informe a hora do acidente.")
            exigir("horasTrabalhadas", form.horasTrabalhadas, "Informe as horas trabalhadas.")
            exigir("localAcidente", form.localAcidente, "Informe o local do acidente.")
            exigir("parteCorpoLesionada", form.parteCorpoLesionada, "Informe a parte do corpo lesionada.")
            exigir("agenteCausador", form.agenteCausador, "Informe o agente causador da lesão.")
            exigir("naturezaLesao", form.naturezaLesao, "Informe a natureza da lesão.")
        }
        if (ativo("acoesTomadasImediato")) {
            exigir("acoesTomadasImediato", form.acoesTomadasImediato, "Informe as ações tomadas de imediato.")
        }
        if (ativo("descricaoEvento")) {
            exigir("descricaoEvento", form.descricaoEvento, "Descreva o evento.")
        }
        if (form.latitude == null || form.longitude == null) {
            erros += ErroCampo("localGps", "Capture o local por GPS.")
        }
        if (ativo("fotos") && form.fotos.isEmpty()) {
            erros += ErroCampo("fotos", "Adicione ao menos uma foto.")
        }
        return erros
    }
}
